const muiLinearProgress = {
  styleOverrides: {
    root: {
      height: 2,
    },
  },
};

export default muiLinearProgress;
